import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';
import styled from 'styled-components';

export const ProducerInfoContainer = styled.div`
  font-size: 10px;
  color: #666;
  gap: 8px;
`;

export const ProducerItem = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-start;
  gap: 4px;
  text-align: left;
  flex-direction: column;
  gap: 2px;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    text-align: right;
    flex-direction: column;
    align-items: flex-start;
  }
`;
